{
  "nav": {
    "pricing": "Precios",
    "contact": "Contacto",
    "menu": "Menú",
    "login": "Iniciar sesión",
    "features": "Funciones",
    "brandHomeAria": "Done-it — inicio",
    "market": {
      "belgium": "Bélgica",
      "international": "Todo el mundo"
    }
  },
  "footer": {
    "tagline": "Done-it — Control horario simple.",
    "terms": "Términos",
    "privacy": "Privacidad",
    "contact": "Contacto"
  },
  "help": "¿Necesitas ayuda?",
  "continue": "Continuar",
  "back": "Atrás",
  "change": "Cambiar",
  "retry": "Reintentar",
  "errors": {
    "unexpected": "Error inesperado"
  },
  "step": {
    "of": "Paso {{n}} de {{total}}"
  },
  "funnel": {
    "title": "Suscripción · Done-it"
  }
}
